import { render, staticRenderFns } from "./videospare.vue?vue&type=template&id=11450cd1&"
import script from "./videospare.vue?vue&type=script&lang=js&"
export * from "./videospare.vue?vue&type=script&lang=js&"
import style0 from "./videospare.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports